import { styled } from '@mui/system';

import Chip from 'components/Chip';
import {
  getButtonBackgroundHoverColor,
  getButtonFontHoverColor
} from 'styles/helpers/getThemeStyles';

const RequiredChip = styled(Chip)(({ theme }) => {
  const defaultLabelTypographyStyles =
    theme.typography.itemDescriptionsAndPrices ?? {};
  return {
    '&.MuiChip-root': {
      backgroundColor:
        getButtonBackgroundHoverColor(theme) ?? theme.palette.mediumSoy,
      marginLeft: '6px'
    },
    '& .MuiChip-label': {
      ...defaultLabelTypographyStyles,
      color: getButtonFontHoverColor(theme) ?? theme.palette.white,
      fontSize: '12px'
    }
  };
});

export default RequiredChip;
